// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchNotFound_root__OjWK0","image":"SearchNotFound_image__46_CJ","title":"SearchNotFound_title___swvk","text":"SearchNotFound_text__OM7El"};